import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr/translation.json';
import ro from './locales/ro/translation.json';
import en from './locales/en/translation.json';

i18next.use(initReactI18next).init({
  lng: localStorage.getItem('i18n_language') || navigator.language.slice(0,2),
  fallbackLng: 'fr',
  returnEmptyString: false,
  resources: {
    fr: { translation: fr },
    ro: { translation: ro },
    en: { translation: en },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
